import styled from "styled-components";

import { border, brand, radius, spacing, status, surface, text, typography } from "../../theme/tokens";

export const SectionTitle = styled.h3`
  font-family: ${typography.fontFamily};
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${text.tertiary};
  margin: ${spacing[5]} 0 ${spacing[2]};
`;

export const TreeWrapper = styled.div`
  border: 1px solid ${border.light};
  border-radius: ${radius.md};
  background: ${surface.folderTint};
  padding: ${spacing[2]};
  /* Sized to a whole number of rows so a long file scrolls from a clean
     edge rather than showing a folder sliced in half. */
  max-height: 336px;
  overflow: auto;
`;

export const FolderRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  color: ${(props) => (props.$muted ? text.disabled : text.primary)};
`;

export const Count = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: ${(props) => (props.$muted ? text.disabled : text.muted)};
  background: ${(props) => (props.$muted ? "transparent" : surface.hover)};
  border-radius: ${radius.sm};
  padding: 0 6px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  margin: ${spacing[3]} 0;
  justify-content: ${(props) => (props.$right ? "flex-end" : "flex-start")};
`;

/**
 * The one line that decides whether the screen is trusted: how many
 * documents this actually sends, and — when they differ — what is being
 * held back and why.
 */
export const Summary = styled.div`
  font-family: ${typography.fontFamily};
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => (props.$none ? text.muted : text.primary)};
  background: ${(props) => (props.$none ? surface.hover : brand.primaryLight)};
  border-radius: ${radius.md};
  padding: ${spacing[2]} ${spacing[3]};
  margin: ${spacing[3]} 0;

  em {
    font-weight: 500;
    font-style: normal;
    color: ${text.secondary};
  }
`;

export const EmptyNote = styled.p`
  font-family: ${typography.fontFamily};
  font-size: 13px;
  color: ${text.muted};
  margin: 0;
`;

export const ActiveShares = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;

export const ActiveShare = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[3]};
  border: 1px solid ${border.light};
  border-radius: ${radius.md};
  padding: ${spacing[2]} ${spacing[3]};
  font-family: ${typography.fontFamily};
`;

export const ShareMeta = styled.div`
  font-size: 12px;
  color: ${text.muted};
`;

export const Panel = styled.div`
  border: 1px solid ${border.light};
  border-radius: ${radius.md};
  background: ${brand.primaryLight};
  padding: ${spacing[3]};
  font-family: ${typography.fontFamily};

  p {
    font-size: 13px;
    color: ${text.secondary};
    margin: 0 0 ${spacing[3]};
  }
`;

export const PanelLabel = styled.div`
  font-weight: 700;
  color: ${text.primary};
  margin-bottom: ${spacing[2]};
`;

/**
 * Amber rather than red: a file being read by an outside expert is a
 * normal, intended state, not a fault. It just needs to be impossible to
 * miss while someone is filing documents into it.
 */
export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: ${typography.fontFamily};
  font-size: 12px;
  font-weight: 600;
  color: ${status.review.fg};
  background: ${status.review.bg};
  border: 1px solid ${status.review.border};
  border-radius: ${radius.pill};
  padding: 2px 10px;
  white-space: nowrap;
`;

export const InviteLink = styled.div`
  display: flex;
  gap: ${spacing[2]};
  margin-bottom: ${spacing[3]};
`;
